import React, { useEffect } from 'react';
import { Box, Button, Stack, Text, Title } from '@mantine/core';

export default function UltraUpgradeComplete() {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: 'white',
      }}
    >
      <Stack
        spacing={0}
        align="center"
        justify="center"
        sx={{
          padding: 24,
          maxWidth: 400,
          width: '100%',
        }}
      >
        <Box sx={{ flex: 1 }} />
        <Box sx={{ textAlign: 'center', marginBottom: 32 }}>
          <Title
            order={1}
            sx={{
              fontSize: 32,
              fontWeight: 700,
              lineHeight: '110%',
              margin: '0 0 12px 0',
            }}
          >
            {'Thank You'}
          </Title>
          <Text
            size={16}
            weight={400}
            sx={{
              lineHeight: '140%',
              color: '#666',
            }}
          >
            {'Lorem ipsum dolor sit amet consectetur'}
          </Text>
        </Box>
        <Button
          radius="lg"
          sx={{
            backgroundColor: 'black',
            color: 'white',
            width: '100%',
            maxWidth: 300,
            height: 44,
            '&:hover': {
              backgroundColor: '#333',
            },
          }}
          onClick={() => {
            window.open('fi://closeappview');
          }}
        >
          {'Done'}
        </Button>
      </Stack>
    </Box>
  );
}
